import React from "react";
import rect1 from "../../../Assets/Images/login-rectangle-1.png";
import rect2 from "../../../Assets/Images/login-rectangle-2.png";
import { IoEarth } from "react-icons/io5";
import "./style.css";

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div
        className="footer-background"
        style={{
          background: `url(${rect1}) no-repeat center bottom / cover, url(${rect2}) no-repeat center bottom / cover`
        }}
      />
      <div className="footer-content">
        <div className="footer-address">
          <p className="footer-company-name">i3 Partners GmbH</p>
          <p>In den Steinreben 4d</p>
          <p>4153 Reinach BL</p>
          <p>Switzerland</p>
          <p className="footer-website">
            <IoEarth size={14} />
            <a
              href="https://www.i3partners.net/"
              target="_blank"
              rel="noreferrer"
            >
              www.i3partners.net
            </a>
          </p>
        </div>
        <p className="footer-text footer-copyright">
          Copyright 2022 <span>&#169;</span>{" "}
          <span className="footer-company-name">i3 Partners GmbH</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
